import { render, staticRenderFns } from "./SubmissionLayoutBuilder.vue?vue&type=template&id=af695766&scoped=true&"
import script from "./SubmissionLayoutBuilder.vue?vue&type=script&lang=js&"
export * from "./SubmissionLayoutBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionLayoutBuilder.vue?vue&type=style&index=0&id=af695766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af695766",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
